/**
 * Created by tdunham on 6/26/2017.
 */
import {Component, OnDestroy, OnInit, ViewChild,
	ViewEncapsulation}                  from '@angular/core';
import {ActivatedRoute,
	NavigationEnd, Router}              from '@angular/router';
import {HttpErrorResponse}              from '@angular/common/http';
import {Ng4LoadingSpinnerService}       from 'ng4-loading-spinner';

import {AngularQuery}                   from "../../services/query/angularquery";
import {DialogService}                  from '../../services/miscellaneous/dialog-service';
import {Message}                        from "../../services/message/message";
import {MessageEntry}                   from "../../services/message/message-entry";
import {MessageService}                 from '../../services/message/message.service';
import {News}                           from "../../services/news/news";
import {NewsService}                    from "../../services/news/news-service";
import {PageSettings}                   from "../../services/news/page-settings";
import {Player}                         from "../../services/player/player";
import {PlayerService}                  from "../../services/player/player.service";
import {Source}                         from "../../services/source/source";
import {SourceService}                  from "../../services/source/source.service";
import {Sport}                          from '../../services/sport/sport';
import {Tag}                            from '../../services/tag/tag';
import {TagService}                     from "../../services/tag/tag.service";
import {Team}                           from "../../services/team/team";
import {TeamService}                    from "../../services/team/team.service";
import {User}                           from "../../services/user/user";

import {forkJoin}                       from "rxjs/observable/forkJoin";
import {isNullOrUndefined}              from "util";
import {Observable}                     from "rxjs/Observable";
import {Subscription}                   from "rxjs/Subscription";



@Component({
	templateUrl: './item.component.html',
	styleUrls: ['./item.component.css'],
	encapsulation: ViewEncapsulation.None,
})

export class ItemComponent implements OnInit, OnDestroy {

	// ARTICLE and STATUS variables.
	article: News;                          // The news article to be displayed in this component.
	errorCheckCount:number = ItemComponent.errorChecks; // Counter to keep track of initializations.
	static errorChecks:number = 5;          // How many error checks to run.
	hidePreview: boolean = true;            // Shows or hides the preview.
	isPreviewed:boolean = true;             // Has the article been previewed yet?
	pageSettings:PageSettings;              // Object that holds the persistent page settings for this user.
	pasteTarget:string = '';                // Used when pasting text.
	preview: Object;                        // The return from the preview post.
	previewSubscription: Subscription;      // Used when previewing the article.
	previewText: string = '';               // What the preview window shows.
	saveSubscription: Subscription;         // Used when saving the article.
	statuses = ItemComponent.getStatuses(); // Set the immutable status information.

	// MESSAGE variables.
	errorMessages: MessageEntry[] = [];     // Used to hold initialization errors.
	message: Message;                       // Notify the user about what's up.
	msgSubscription: Subscription;          // The subscription for the MessageService.

	// PLAYER variables.
	players: Player[] = [];                 // The array of Player objects associated with this article.
	playerSubscription: Subscription;       // Used to fill in the Players list on page load.

	// ROUTER variables.
	navigationSubscription: Subscription;   // Allows reloading of same page.

	// SOURCE variables.
	source: Source;                         // The current Source.
	sources: Observable<Source[]>;          // The sources found via search.
	sourceSubscription: Subscription;       // Used to fill in the Source variable on page load.

	// SPORT variables.
	sport:Sport;                            // The current Sport.
	sports: Sport[];                        // The array of information about each Sport choice.

	// TAG and CHECKBOX variables.
	checkboxSubscription: Subscription;     // The Subscription for the checkbox Tag service.
	tags: Tag[] = [];                       // The array of tags associated with this article.
	tagsCheckboxes: Tag[] = [];             // Holds the retrieved checkbox information.
	tagSubscription: Subscription;          // The Subscription for the news Tag service.

	// TEAM variables.
	team: Team;                             // The current Team.
	teams: Observable<Array<Team>>;         // The teams found via search.
	teamSubscription: Subscription;         // Used to fill in the Team variable on page load.


	/**
	 * Initialize the service that supplies the information
	 * this editor can work with.
	 *
	 * @param dialogService   The DialogService singleton.
	 * @param msgSvc          The MessageService to notify the user about status.
	 * @param newsService     The NewsService singleton.
	 * @param playerService   The PlayerService singleton.
	 * @param route           ActivatedRoute used to retrieve the data.
	 * @param router          The Router singleton used for navigation.
	 * @param sourceService   The SourceService singleton.
	 * @param spinnerService  The Ng4LoadingSpinnerService singleton for displaying the spinner on this page.
	 * @param tagService      The TagService singleton.
	 * @param teamService     The TeamService singleton.
	 */
	constructor(

		private dialogService: DialogService,
		protected msgSvc: MessageService,
		private newsService: NewsService,
		private playerService: PlayerService,
		private route: ActivatedRoute,
		private router: Router,
		private sourceService: SourceService,
		private spinnerService: Ng4LoadingSpinnerService,
        private tagService: TagService,
        private teamService: TeamService,

	) {

		// Support reload of page; this fires every time the Router completes its process.
		this.navigationSubscription = this.router.events.subscribe((e: any) => {

			// Retrieve and display the appropriate information.
			if (e instanceof NavigationEnd) {
				this.initialize();
			}

		});

	}


	/**
	 * This runs once, after the constructor is finished,
	 * to create the list of Sports and News in the search window.
	 *
	 * @return void
	 */
	ngOnInit(): void {

		// Set up communications with the MessageService.
		this.msgSubscription = this.msgSvc.subject.subscribe( message => { this.message = message; } );

	}


	/**
	 * Unsubscribe from subscriptions to avoid memory leaks.
	 */
	ngOnDestroy() {

		if (this.checkboxSubscription) {
			this.checkboxSubscription.unsubscribe();
		}

		if (this.msgSubscription) {
			this.msgSubscription.unsubscribe();
		}

		if (this.navigationSubscription) {
			this.navigationSubscription.unsubscribe();
		}

		if (this.playerSubscription) {
			this.playerSubscription.unsubscribe();
		}

		if (this.previewSubscription) {
			this.previewSubscription.unsubscribe();
		}

		if (this.saveSubscription) {
			this.saveSubscription.unsubscribe();
		}

		if (this.sourceSubscription) {
			this.sourceSubscription.unsubscribe();
		}

		if (this.tagSubscription) {
			this.tagSubscription.unsubscribe();
		}

		if (this.teamSubscription) {
			this.teamSubscription.unsubscribe();
		}

	}


	/**
	 * Controls the Article body TEXTAREA.
	 */
	@ViewChild('articleBody')
	articleBody: any;


	/**
	 * Controls the Article Title INPUT.
	 */
	@ViewChild('articleTitle')
	articleTitle: any;


	/**
	 * Controls the Fantasy Tip TEXTAREA.
	 */
	@ViewChild('fantasyTip')
	fantasyTip: any;


	/**
	 * Controls the FORM object.
	 */
	@ViewChild('itemForm')
	itemForm: any;


	/**
	 * Link to the player typeahead.
	 */
	@ViewChild('playerTypeahead')
	playerTypeahead:any;


	/**
	 * Controls the Player Code checkbox.
	 */
	@ViewChild('searchPlayerCodeCheckbox')
	searchPlayerCodeCheckbox: any;


	/**
	 * Controls the Player Team checkbox.
	 */
	@ViewChild('searchPlayerTeamCheckbox')
	searchPlayerTeamCheckbox: any;


	/**
	 * Link to the source typeahead.
	 */
	@ViewChild('sourceTypeahead')
	sourceTypeahead:any;


	/**
	 * Controls the Source URL INPUT.
	 */
	@ViewChild('sourceURL')
	sourceURL: any;


	/**
	 * Link to the source typeahead.
	 */
	@ViewChild('tagTypeahead')
	tagTypeahead:any;


	/**
	 * Link to the team typeahead.
	 */
	@ViewChild('teamTypeahead')
	teamTypeahead:any;


	/**
	 * This is run when the user selects a player from
	 * the provided list.  It ADDS a player to the existing
	 * list after checking that the chosen player is not
	 * already in the list.
	 *
	 * @param {Player} player   The Player choice made by the user.
	 */
	addPlayer(player: Player): void {

		// Mark the page as dirty.
		this.itemForm.form.markAsDirty();

		// Don't allow duplicate tags into the Tag list.
		for (let key of this.players) {

			if (key.id == player.id) {

				return;

			}

		}

		this.players.push(player);  // Add the player to the list if not found.

	}


	/**
	 * This is run when the user selects a tag from
	 * the provided list.  It ADDS a tag to the existing
	 * list after checking that the chosen tag is not
	 * already in the list.
	 *
	 * @param {any} event   The Tag choice made by the user as an event object.
	 */
	addTag(event: any): void {

		// Convert it from an event to a Tag.
		let tag: Tag = new Tag(event);
		event.cancelBubble = true;

		// Mark the page as dirty and clear the tag typeahead field.
		this.itemForm.form.markAsDirty();

		// If it's in the checkbox list, check it and quit.
		for (let key of this.tags) {

			if (key.id == tag.id) {

				key.checked = 1;
				return;

			}

		}

		// If we get here, this was a tag that was not already in the list.
		tag.checked = 1; // Check the tag.
		tag.sport_checkbox = false; // It is not a sport checkbox tag.
		this.tags.push(tag);  // Add the tag to the list if it wasn't found.

	}


	/**
	 * This is run each time an initialization is completed.  The last
	 * initialization causes the success/fail message to be displayed.
	 */
	afterInitialization(): void {

		this.errorCheckCount = this.errorCheckCount - 1;

		if (this.errorCheckCount > 0) {

			return;

		}

		// Don't allow the 'success' message to be displayed if something went wrong while loading.
		if (0 !== this.errorMessages.length) {

			// This is a HACK! It has to be sent in the next Angular 'tick' to avoid an error message.
			setTimeout(()=>{
				this.msgSvc.mergeMessagesAndSend(this.errorMessages);
			}, 0);

			return;

		}

		// Send the successful load message.
		let loadMessage: string = '';

		if (-1 === this.article.id) {

			loadMessage = 'Created new article';

		} else {

			loadMessage = 'Successfully loaded article #' + this.article.id;

		}

		// This is a HACK! It has to be sent in the next Angular 'tick' to avoid an error message.
		setTimeout(()=>{
			this.msgSvc.sendMessageEntry(new MessageEntry({
				message: loadMessage,
				level: 1
			}));
		}, 0);

	}


	/**
	 * User presses 'Cancel' button; the guard function keeps
	 * them from navigating away if they change their minds.
	 */
	cancelArticleEdit(): void {

		this.router.navigate(['/articles/list']);

	}


	/**
	 * Decide if the user wants to throw away their changes or not.
	 *
	 * @returns {any} True if they want to throw away changes, false otherwise.
	 */
	canDeactivate(): Promise<boolean> | boolean {

		// Allow synchronous navigation if nothing has changed.
		if (this.itemForm.form.pristine) {

			return true;

		}

		// Let the user decide to throw away their changes.
		return this.dialogService.confirm('Throw away changes?');

	}


	/**
	 * Clear the team choice, re-retrieve the checkboxes.
	 */
	changeSport(spt:Sport) {

		this.sport = spt;
		this.article.code = this.sport.db_enum;
		this.itemForm.form.markAsDirty(); // Mark the page as dirty.

		// Clear out the current team information.
		this.team = null; // Clear the current team.
		this.teamTypeahead.typeaheadTeamInput.nativeElement.value = '';

		// Remove all unmarked tags from the tag list.  Set the checkbox tags for any that are left to false.
		let entry: Tag;
		let keepers: Tag[] = [];

		while (this.tags.length > 0) {

			entry = this.tags.shift();

			if (1 === entry.checked) {

				entry.sport_checkbox = false;
				keepers.push(entry);

			}

		}

		this.tags = keepers;

		this.initializeCheckboxes();

	}


	/**
	 * Create a new article.
	 *
	 */
	createArticle(): void {

		this.router.navigate(['/articles/item/new']);

	}


	/**
	 * Perform a search and replace on the content in the named
	 * component so we can filter out Microsoft Word text pasted
	 * in by a user.  This performs the text replacement one timer
	 * tick after the text is pasted into the field.
	 *
	 * @param $event  The event associated with the change in content.
	 */
	fixPastedContent($event: any): void {

		// Keep track of which field needs to be changed.
		this.pasteTarget = $event.target.name;

		// Perform the search and replace on the selected field.  We needed the timeout so the paste occurs
		setTimeout(()=>{
			switch (this.pasteTarget) {
				case 'fantasy_story_source_text':
					this.articleBody.nativeElement.value = ItemComponent.replaceWordCharacters(this.articleBody.nativeElement.value);
					break;
				case 'title':
					this.articleTitle.nativeElement.value = ItemComponent.replaceWordCharacters(this.articleTitle.nativeElement.value);
					break;
				case 'fantasy_tip':
					this.fantasyTip.nativeElement.value = ItemComponent.replaceWordCharacters(this.fantasyTip.nativeElement.value);
					break;
			}
		}, 0);

	}


	/**
	 * Format the provided Date value to an iso8601
	 * string value ("yyyy-MM-ddThh:mm:ss").
	 *
	 * @param date       The Date value to convert.
	 * @returns {string} An ISO 8601 string of the provided Date.
	 */
	formatDateToIso8601(date: Date): string {

		let year: string = date.getFullYear().toString();
		let nMonth: number = date.getMonth() + 1;  // Months begin at 0 and ascend to 11.
		let month: string = nMonth.toString();
		let day: string = date.getDate().toString();
		let hour: string = date.getHours().toString();
		let minutes: string = date.getMinutes().toString();
		let seconds: string = date.getSeconds().toString();

		// Make sure the strings are formatted correctly.
		month = (1 == month.length) ? '0' + month : month;
		day = (1 == day.length) ? '0' + day : day;
		hour = (1 == hour.length) ? '0' + hour : hour;
		minutes = (1 == minutes.length) ? '0' + minutes : minutes;
		seconds = (1 == seconds.length) ? '0' + seconds : seconds;

		return year.concat('-', month, '-', day, 'T', hour, ':', minutes, ':', seconds);

	}


	/**
	 * Convert the supplied Date to something that
	 * will save correctly in MySQL.
	 *
	 * @param date       The Date value to convert.
	 * @returns {string} A MySQL-formatted string of the provided Date.
	 */
	public static formatDateToMysql(date: Date): string {

		let year: string = date.getUTCFullYear().toString();
		let nMonth: number = date.getUTCMonth() + 1;  // Months begin at 0 and ascend to 11.
		let month: string = nMonth.toString();
		let day: string = date.getUTCDate().toString();
		let hour: string = date.getUTCHours().toString();
		let minutes: string = date.getUTCMinutes().toString();
		let seconds: string = date.getUTCSeconds().toString();

		// Make sure the strings are formatted correctly.
		month = (1 == month.length) ? '0' + month : month;
		day = (1 == day.length) ? '0' + day : day;
		hour = (1 == hour.length) ? '0' + hour : hour;
		minutes = (1 == minutes.length) ? '0' + minutes : minutes;
		seconds = (1 == seconds.length) ? '0' + seconds : seconds;

		return year.concat('-', month, '-', day, ' ', hour, ':', minutes, ':', seconds);

	}


	/**
	 * Get the data to for the POST of this article.
	 *
	 * @returns {Object} Article data formatted for POST.
	 */
	getPostObject(): Object {

		let post: Object = {};

		// Read the article object and convert its fields.
		for (let key in this.article) {

			// Handle the date field separately.
			if ('date' === key) {

				post[key] = ItemComponent.formatDateToMysql(this.article.date);
				continue;

			}

			post[key] = this.article[key];

		}

		// Add the players, tags and team.
		post['players'] = [];
		post['tags'] = [];
		post['team'] = [];
		post['team'].push(this.team.id);

		for (let p of this.players) {

			post['players'].push(p.id);

		}

		for (let t of this.tags) {

			if (t.checked) {

				post['tags'].push(t.id);

			}

		}

		return post;

	}


	/**
	 * Create the preview in the Preview tab.
	 */
	getPreview(): void {

		// Don't let them request a preview if the data is invalid.
		if (isNullOrUndefined(this.team) || 0 === this.article.body.trim().length) {

			let msg:string = 'There must be content in the article before previewing';

			if (isNullOrUndefined(this.team)) {

				msg = 'You must select a team before previewing';

			}

			this.msgSvc.sendMessageEntry(new MessageEntry({

				message: msg,
				level: 4

			}));
			return;

		}

		// Turn on the spinner so they know to wait.
		this.spinnerService.show();

		// Clear the existing text from the window.
		this.previewText = '';
		this.hidePreview = true;

		// Create the query that will give us a URL.
		let query: AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_NEWS_PARSER);
		query.useParams(false);
		query.useCacheBuster(false);

		// Create the object that contains the preview data.
		let post: Object = {};
		post['article'] = this.article.body;
		post['code'] = this.article.code;
		post['players'] = this.players;
		post['tags'] = this.listCheckedTags();
		post['team'] = this.team.id;
		post['title'] = this.article.title;

		// Clear any existing preview subscriptions so we always start fresh.
		if (this.previewSubscription) {
			this.previewSubscription.unsubscribe();
		}

		// Set up the subscription that gets the preview.
		this.previewSubscription = this.newsService.postParseRequest(query.getUrl(), JSON.stringify(post)).subscribe(

			(response) => {

				this.preview = response;

				// This stops processing here if an error was caught by news-service.
				if (true !== response['valid']) {

					this.msgSvc.sendMessageEntry(new MessageEntry({

						message: 'Preview error!',
						level: 4

					}));

					this.spinnerService.hide();
					return;

				}

				let playerCounter:number = 0;
				let tagCounter:number = 0;

				// The parser may not find a team, so only process if one is found.
				if (Number.isInteger(response['team']['id'])) {

					this.team = new Team(response['team']);

				}

				// Add the players to the list.
				if (0 !== response['players'].length) {

					for (let entry of response['players']) {

						this.addPlayer(new Player(entry));
						playerCounter++;


					}

				}

				if (0 !== response['tags'].length) {

					let incoming: Tag;

					for (let entry of response['tags']) {

						incoming = new Tag(entry);

						for (let existing of this.tags) {

							if (existing.id === incoming.id) {

								existing.checked = 1;

							}

						}

						this.addTag(incoming);
						tagCounter++;

					}

				}

				this.isPreviewed = true;
				this.previewText = response['article'];
				this.hidePreview = false;
				let msg:string = 'Preview complete';

				if (0 !== tagCounter) {
					msg = msg + '. Tags added ' + String(tagCounter);
				}

				if (0 !== playerCounter) {
					msg = msg + '. Players added ' + String(playerCounter);
				}

				this.msgSvc.sendMessageEntry(new MessageEntry({

					message: msg,
					level: 1

				}));

			},

			error => {

				let msg: string = 'Unable to preview article';

				if (error instanceof HttpErrorResponse) {

					let body:any = error || '';

					if (! isNullOrUndefined(body.message)) {

						msg = 'Unable to preview: ' + body.message;

					}

				}

				this.isPreviewed = false;
				this.msgSvc.sendMessageEntry(new MessageEntry({

					message: msg,
					level: 4

				}));
				this.spinnerService.hide();

			},

			() => {

				this.spinnerService.hide();

			}
		);

	}


	/**
	 * Prepare for an article save by setting up the AngularQuery
	 * and clearing the previous saveSubscription.
	 *
	 * @returns {AngularQuery}  Query for saving the current article.
	 */
	getSaveArticleQuery(): AngularQuery {

		let query: AngularQuery = new AngularQuery();
		query.useParams(false);
		query.useCacheBuster(false);

		// Provide the proper argument to the endpoint.
		if (-1 == this.article.id) {

			query.setEndpoint(AngularQuery.ENDPOINT_NEWS, 'new');

		} else {

			query.setEndpoint(AngularQuery.ENDPOINT_NEWS, this.article.id.toString());

		}

		// Remove any old subscriptions before starting a new one.
		if (this.saveSubscription) {

			this.saveSubscription.unsubscribe();

		}

		return query;

	}


	/**
	 * Find the Sport object based on the supplied
	 * code.
	 *
	 * @param code
	 * @returns {any}
	 */
	getSportByCode(code: string): Sport {

		for (let sport of this.sports) {

			if (code === sport.db_enum) {
				return sport;
			}

		}

		return null;

	}


	/**
	 * Retrieve the array of post statuses used
	 * to create the pulldown and to display the
	 * status in a list.
	 *
	 * @returns Array of post statuses.
	 */
	static getStatuses() {
		return [
			{ name: 'trash',   label: 'Trash',   list: 'Trash',     visible: -1 },
			{ name: 'draft',   label: 'Draft',   list: 'Draft',     visible: 0  },
			{ name: 'publish', label: 'Publish', list: 'Published', visible: 1  },
			{ name: 'future',  label: 'Future',  list: 'Future',    visible: 2  },
		];
	}


	/**
	 * Set up to display the article information.
 	 */
	initialize(): void {

		// Clear out any leftover stuff from the previous article.
		this.errorCheckCount = ItemComponent.errorChecks;
		this.isPreviewed = true;
		this.players = [];
		this.source = null;
		this.tags = [];
		this.tagsCheckboxes = [];
		this.team = null;
		this.errorMessages = [];
		this.sourceTypeahead.typeaheadSourceInput.nativeElement.value = '';
		this.teamTypeahead.typeaheadTeamInput.nativeElement.value = '';
		this.playerTypeahead.typeaheadPlayerNameInput.nativeElement.value = '';

		// Initialize the session settings.
		let ps:string = sessionStorage.getItem('pageSettings') || '{}';
		this.pageSettings = new PageSettings(JSON.parse(ps));

		// Handle ID error, retrieve the article data or set up for a new article.
		if ("article" in this.route.snapshot.data
			&& Number.isInteger(this.route.snapshot.data['article']['id'])
			&& -1 === this.route.snapshot.data['article']['id']
		) {

			// No article was found for the provided ID.
			this.router.navigate(['/pagenotfound']);
			return;

		} else if ("article" in this.route.snapshot.data && Number.isInteger(this.route.snapshot.data['article']['id'])) {

			// Set up the article based on the article ID.
			this.article = new News(this.route.snapshot.data['article']);
			this.article.date = new Date(this.article.date);

		} else {

			// Set the default sport, from the settings, if possible.
			let code:string = 'NFL';

			if (this.pageSettings.initialized && ! isNullOrUndefined(this.pageSettings.currentItemSport)) {

				code = this.pageSettings.currentItemSport;

			}

			// Create a new, blank article and clear out any evidence of a previous article because of Angular reload limitations.
			let defaults: Object = { 'hot': 0, 'title': '', 'body': '', 'fantasy_tip': '', 'huddle_tip': '', 'baseball_tip': '',
				'code': code, 'visible': 1, 'date': new Date(), 'id': -1, 'source_id': 1, 'original_url': '',
			};

			// Create a new, empty article from the defaults.
			this.article = new News(defaults);
			this.errorCheckCount = 1;

		}

		// Set the author information from the session's User variable.
		let userString:string = sessionStorage.getItem('currentUser');
		if (null !== userString) {
			let user:User = new User(JSON.parse(userString));
			this.article.user_id = user.id;
		}

		// Used later to see if the body text has changed.
		this.previewText = this.article.body;

		this.setDate(this.article.date);

		// Initialize the sports array and fill it with the retrieved data, then set the currently selected sport.
		this.sports = this.route.snapshot.data['sports'];
		this.sport = this.getSportByCode(this.article.code);

		// Set up the checkboxes based on the sport selection.
		this.initializeCheckboxes();

		// These are only initialized for existing articles.
		if (-1 !== this.article.id) {

			this.initializePlayers();
			this.initializeSource();
			this.initializeTags();
			this.initializeTeam();

		}

	}


	/**
	 * Retrieve the Sport checkbox tags for this article and initialize the display.
	 */
	initializeCheckboxes(): void {

		let sport: Sport = this.getSportByCode(this.article.code);

		if (null != sport) {

			this.checkboxSubscription = this.tagService.getCheckboxes(sport.id).subscribe(

				(tags) => this.tagsCheckboxes = tags,

				(error) => {

					this.tagsCheckboxes = [];

					if (error instanceof HttpErrorResponse && 404 !== error.status) {

						this.errorMessages.push(new MessageEntry({
							message: 'Failed to retrieve checkbox information due to server error',
							level: 4
						}));

					}

					this.afterInitialization();

				},

				() => {

					this.integrateTags();
					this.afterInitialization();

				}

			);

		} else {

			this.errorMessages.push(new MessageEntry({
				message: 'Failed to retrieve checkbox information (no sport selected)',
				level: 4
			}));

			this.afterInitialization();

		}

	}


	/**
	 * Get the initial list of players for this story.
	 */
	initializePlayers(): void {

		this.playerSubscription = this.playerService.getPlayersByArticleId(this.article.id).subscribe(

			response => {

				for (let player of response) {

					this.players.push(new Player(player));

				}

			},

			(error) => {

				this.players = [];

				if (error instanceof HttpErrorResponse && 404 !== error.status) {

					this.errorMessages.push(new MessageEntry({
						message: 'Failed to retrieve players due to server error',
						level: 4
					}));

				}

				this.afterInitialization();

			},

			() => {

				this.afterInitialization();

			}
		);

	}


	/**
	 * Get the source for this story and initialize the field.
	 */
	initializeSource(): void {

		this.sourceSubscription = this.sourceService.getSource(this.article.source_id).subscribe(

			response => {

				this.source = new Source(response);

				if (! isNullOrUndefined(this.source.name)) {

					this.sourceTypeahead.typeaheadSourceInput.nativeElement.value = this.source.name;

				}

			},

			(error) => {

				if (error instanceof HttpErrorResponse && 404 !== error.status) {

					this.errorMessages.push(new MessageEntry({
						message: 'Failed to retrieve source due to server error',
						level: 4
					}));

				}

				this.afterInitialization();

			},

			() => {

				this.afterInitialization();

			}

		);

	}


	/**
	 * Retrieve the existing tags for this article and populate the field for them.
	 */
	initializeTags(): void {

		let tagQuery:AngularQuery = new AngularQuery();
		tagQuery.setEndpoint(AngularQuery.ENDPOINT_NEWS_TAGS, this.article.id.toString());
		tagQuery.setPerPage(100);

		this.tagSubscription = this.tagService.getTags(tagQuery).subscribe(

			tags => this.tags = tags,

			(error) => {

				this.tags = [];

				if (error instanceof HttpErrorResponse && 404 !== error.status) {

					this.errorMessages.push(new MessageEntry({
						message: 'Failed to initialize tags due to server error',
						level: 4
					}));

				} else {

					this.integrateTags();

				}

				this.afterInitialization();

			},

			() => {

				this.integrateTags();
				this.afterInitialization();
			}

		);

	}


	/**
	 * Get the Team for this story and set the initial value in the search window.
	 */
	initializeTeam(): void {

		this.teamSubscription = this.teamService.getTeamByArticleId(this.article.id).subscribe(

			team => {

				this.team = new Team(team);
				if (! isNullOrUndefined(this.team.title)) {

					this.teamTypeahead.typeaheadTeamInput.nativeElement.value = this.team.title;

				}

			},

			(error) => {

				if (error instanceof HttpErrorResponse && 404 !== error.status) {

					this.errorMessages.push(new MessageEntry({
						message: 'Failed to retrieve team data due to server error',
						level: 4
					}));

				}

				this.afterInitialization();

			},

			() => {

				this.afterInitialization();

			}

		);

	}


	/**
	 * When the tag and checkbox retrievals are complete, merge the two lists.
	 */
	integrateTags(): void {

		if (isNullOrUndefined(this.tagsCheckboxes) || isNullOrUndefined(this.tags)) {
			return;
		}

		// Set the "checked" attribute of all the tags from the tag query.
		for (let tag of this.tags) {

			tag.checked = 1;
			tag.sport_checkbox = false;

		}

		// Loop through each of the checkbox tags, looking for a match in the tags array. If not found, add it to tags.
		let found: boolean;

		for (let checkbox of this.tagsCheckboxes) {

			found = false;

			for (let tag of this.tags) {

				if (tag.id == checkbox.id) {

					tag.sport_checkbox = true;
					found = true;
					break;

				}

			}

			if (! found) {

				checkbox.checked = 0;
				checkbox.sport_checkbox = true;
				this.tags.push(checkbox);

			}

		}

		// Sort the tags alphabetically.
		this.tags.sort(function(a, b){

			return a.tag.toLocaleLowerCase().localeCompare(b.tag.toLocaleLowerCase());

		});

	}


	/**
	 * This is used by the Sport radio button to
	 * turn the selected value a different color.
	 *
	 * @param name  The 'code' value for the radio button.
	 * @returns {any} A style object with content or empty.
	 */
	isHighlighted(name: string): any {

		if (name === this.article.code) {

			return {'color': 'blue', 'font-weight': 'bold'};

		}

		return {};

	}


	/**
	 * This is used by the Hot radio buttons to
	 * turn the selected value a different color.
	 *
	 * @param status  The value (0 or 1) for the radio button.
	 * @returns {any} A style object with content or empty.
	 */
	isHotHighlighted(status: number): any {

		if (status === this.article.hot) {

			return {'color': 'blue', 'font-weight': 'bold'};

		}

		return {};

	}


	/**
	 * Return only the checkbox tags from the
	 * current list of tags.
	 *
	 * @returns {Tag[]}  An array of Tag objects that are designated as checkbox tags for the selected sport.
	 */
	listCheckboxTags(): Tag[] {

		let found: Tag[] = [];

		if (! isNullOrUndefined(this.tags)) {

			for (let tag of this.tags) {

				if (true == tag.sport_checkbox) {

					found.push(tag);

				}

			}

		}

		return found;

	}


	/**
	 * Return only the tags that are checked, whether they are for checkboxes or not.
	 */
	listCheckedTags(): Tag[] {

		let found: Tag[] = [];

		if (! isNullOrUndefined(this.tags)) {

			for (let tag of this.tags) {

				if (1 == tag.checked) {

					found.push(tag);

				}

			}

		}

		return found;

	}


	/**
	 * Return only the tags that are not designated as checkbox tags from the current list of tags.
	 * This only returns tags that are marked as checked.
	 *
	 * @returns {Tag[]}  An array of Tag objects that are not designated as checkbox tags for the selected sport.
	 */
	listUserTags(): Tag[] {

		let found: Tag[] = [];

		if (! isNullOrUndefined(this.tags)) {

			for (let tag of this.tags) {

				if (false == tag.sport_checkbox && 1 == tag.checked) {

					found.push(tag);

				}

			}

		}

		return found;

	}


	/**
	 * Sets isPreviewed to false if the saved preview text
	 * is not the same as the current article body text.
	 */
	needsPreview(): void {

		if (this.isPreviewed && this.previewText !== this.articleBody.nativeElement.value) {

			this.isPreviewed = false;

		}

	}

	/**
	 * Add the user's player choice to the list.
	 *
	 * @param event  The Player chosen by the user.
	 */
	onPlayerChange(event:any): void {

		this.itemForm.form.markAsDirty(); // Mark the page as dirty.
		let player:Player = new Player(event);
		this.addPlayer(player);

	}


	/**
	 * Save the user's Source choice.
	 *
	 * @param event  The Source chosen by the user.
	 */
	onSourceChange(event:any): void {

		this.source = new Source(event);
		this.itemForm.form.markAsDirty(); // Mark the page as dirty.
		this.article.source_id = this.source.id;  // Set the source for the article object.
		this.sourceURL.nativeElement.focus();  // Switch to the next field.

	}


	/**
	 * Store the user's Team choice.
	 *
	 * @param event  The Team chosen by the user.
	 */
	onTeamChange(event:any): void {

		this.team = new Team(event);
		this.itemForm.form.markAsDirty(); // Mark the page as dirty.

		// Set the beginning of the title field based on the team choice.
		if (0 === this.article.title.length) {

			this.article.title = ('Free Agent' === this.team.shorttitle) ? 'NFL | ' : this.team.shorttitle + ' | ';

		}
		this.articleTitle.nativeElement.focus();

	}


	/**
	 * Remove the specified Player from the players associated
	 * with this article.
	 *
	 * @param {Player} player  The object to remove.
	 */
	removePlayer(player: Player): void {

		// Filter the list to remove the player.
		this.players = this.players.filter(entry => entry.id !== player.id);

		// Mark the page as dirty.
		this.itemForm.form.markAsDirty();

	}


	/**
	 * Uncheck the specified Tag from the tags associated
	 * with this article.
	 *
	 * @param {Tag} tag  The Tag object to uncheck.
  	 */
	removeTag(tag: Tag): void {

		// Mark the page as dirty.
		this.itemForm.form.markAsDirty();

		for (let entry of this.tags) {

			if (tag.id == entry.id) {

				entry.checked = 0;
				break;

			}

		}

	}


	/**
	 * Replace all the Microsoft Word characters from the 128-255 character
	 * positions with appropriate values.
	 *
	 * @param text The text to perform replacements on.
	 */
	public static replaceWordCharacters(text:string): string {

		let s:string = text;
		s = s.replace(/[\u20AC\u2020\u2021\u2030\u00A2\u00A3\u00A4\u00A5\u00A7\u00A8\u00AA\u00AD\u00AF\u00B0\u00B1\u00B2\u00B3\u00B4\u00B5\u00B6\u00B7\u00B8\u00B9\u00BA\u00DE\u00FE]/g, "");
		s = s.replace(/[\u00C0\u00C1\u00C2\u00C3\u00C4\u00C5]/g, "A");
		s = s.replace(/[\u00E0\u00E1\u00E2\u00E3\u00E4\u00E5]/g, "a");
		s = s.replace(/[\u00C8\u00C9\u00CA\u00CB]/g, "E");
		s = s.replace(/[\u00E8\u00E9\u00EA\u00EB]/g, "e");
		s = s.replace(/[\u00CC\u00CD\u00CE\u00CF]/g, "I");
		s = s.replace(/[\u00EC\u00ED\u00EE\u00EF]/g, "i");
		s = s.replace(/[\u00D2\u00D3\u00D4\u00D5\u00D6\u00D8]/g, "O");
		s = s.replace(/[\u00F2\u00F3\u00F4\u00F5\u00F6\u00F8]/g, "o");
		s = s.replace(/[\u00D9\u00DA\u00DB\u00DC]/g, "U");
		s = s.replace(/[\u00F9\u00FA\u00FB\u00FC]/g, "u");
		s = s.replace(/[\u0178\u00DD]/g, "Y");
		s = s.replace(/[\u00FD\u00FF]/g, "Y");
		s = s.replace(/[\u201C\u201D\u201E]/g, "\"");
		s = s.replace(/[\u2018\u2019\u201A]/g, "\'");
		s = s.replace(/[\u0192]/g, "f");
		s = s.replace(/[\u2026]/g, "...");
		s = s.replace(/[\u02C6]/g, "^");
		s = s.replace(/[\u0160]/g, "S");
		s = s.replace(/[\u2039]/g, "<");
		s = s.replace(/[\u0152]/g, "OE");
		s = s.replace(/[\u017D]/g, "Z");
		s = s.replace(/[\u2022]/g, "*");
		s = s.replace(/[\u2013]/g, "-");
		s = s.replace(/[\u2014]/g, "--");
		s = s.replace(/[\u02DC]/g, "~");
		s = s.replace(/[\u2122]/g, "(TM)");
		s = s.replace(/[\u0161]/g, "s");
		s = s.replace(/[\u203A]/g, ">");
		s = s.replace(/[\u0153]/g, "oe");
		s = s.replace(/[\u017E]/g, "z");
		s = s.replace(/[\u00A0]/g, " ");
		s = s.replace(/[\u00A1]/g, "!");
		s = s.replace(/[\u00A6]/g, "|");
		s = s.replace(/[\u00A9]/g, "(C)");
		s = s.replace(/[\u00AB]/g, "<<");
		s = s.replace(/[\u00AC]/g, " ! ");
		s = s.replace(/[\u00AE]/g, "(R)");
		s = s.replace(/[\u00BB]/g, ">>");
		s = s.replace(/[\u00BC]/g, " 1/4");
		s = s.replace(/[\u00BD]/g, " 1/2");
		s = s.replace(/[\u00BE]/g, " 3/4");
		s = s.replace(/[\u00BF]/g, "?");
		s = s.replace(/[\u00C6]/g, "AE");
		s = s.replace(/[\u00C7]/g, "C");
		s = s.replace(/[\u00D0]/g, "ETH");
		s = s.replace(/[\u00D1]/g, "N");
		s = s.replace(/[\u00D7]/g, " x ");
		s = s.replace(/[\u00DF]/g, "s");
		s = s.replace(/[\u00E6]/g, "ae");
		s = s.replace(/[\u00E7]/g, "c");
		s = s.replace(/[\u00F0]/g, "eth");
		s = s.replace(/[\u00F1]/g, "n");
		s = s.replace(/[\u00F7]/g, " / ");
		return s;

	}


	/**
	 * Save the article and then navigate to the new
	 * article's URL with the actual ID if the save is successful.
	 *
	 * The page state also will go to "pristine" again
	 * because it technically is a new page.
	 */
	saveArticle(): void {

		if (! this.itemForm.form.valid) {

			window.alert('This form has invalid fields. Set all required fields and try again.');
			return;

		}

		// Save the user settings.
		this.pageSettings.currentItemSport = this.sport.db_enum;
		sessionStorage.setItem('pageSettings', JSON.stringify(this.pageSettings));

		// Set up the subscription that saves the article.
		let query: AngularQuery = this.getSaveArticleQuery();
		forkJoin([this.newsService.postNewsItem(query.getUrl(), JSON.stringify(this.getPostObject()))]).subscribe(

			(results) => {

				// Set the article ID for new articles.
				let reload: boolean = false;

				if (-1 == this.article.id) {

					this.article.id = results[0];
					reload = true;

				}

				this.itemForm.form.markAsPristine();
				this.itemForm.form.markAsUntouched();

				// Jump to the page with the proper ID.
				if (reload) {

					this.router.navigate(['/articles/item', this.article.id]);

				} else {

					this.msgSvc.sendMessageEntry(new MessageEntry({

						message: 'Saved article \'' + this.article.title + '\'',
						level: 2

					}));

				}

			},
			(error) => {

				let msg: string = 'Unable to save article';

				if (error instanceof HttpErrorResponse) {

					let body:any = error || '';

					if (! isNullOrUndefined(body.message)) {

						msg = body.message;

					}

				}

				this.msgSvc.sendMessageEntry(new MessageEntry({

					message: msg,
					level: 4

				}));

			}

		);

	}


	/**
	 * Save the article.  If the save is successful,
	 * create an article with "/new".
	 */
	saveArticleThenNewArticle(): void {

		if (! this.itemForm.form.valid) {

			window.alert('This form has invalid fields. Set all required fields and try again.');
			return;

		}

		// Save the user settings.
		this.pageSettings.currentItemSport = this.sport.db_enum;
		sessionStorage.setItem('pageSettings', JSON.stringify(this.pageSettings));

		// Set up the subscription that saves the article.
		let query: AngularQuery = this.getSaveArticleQuery();
		this.saveSubscription = this.newsService.postNewsItem(query.getUrl(), JSON.stringify(this.getPostObject())).subscribe(

			() => {

				// Mark the form so the validator will let us leave.
				this.itemForm.form.markAsPristine();
				this.itemForm.form.markAsUntouched();

				// Create a new article.
				this.createArticle();

			},

			error => {

				let msg: string = 'Unable to save article';

				if (error instanceof HttpErrorResponse) {

					let body:any = error || '';

					if (! isNullOrUndefined(body.message)) {

						msg = body.message;

					}

				}

				this.msgSvc.sendMessageEntry(new MessageEntry({

					message: msg,
					level: 4

				}));

			}
		);

	}


	/**
	 * Set the article's date to the current time.
	 */
	setDate(date: Date): void {

		date.setMilliseconds(0);
		date.setSeconds(0);
		this.article.date = date;

	}


	/**
	 * Set the article's date to the current time.
	 *
	 * @returns void
	 */
	setNow(): void {

		this.setDate(new Date());
		// This forces the form to be marked as changed.
		this.itemForm.form.markAsDirty();

	}


	/**
	 * This method is called whenever the user changes the value
	 * of the Date picker on the page.
	 *
	 * @param {Event} event  The "change" Event object that triggered things.
	 * @returns void
	 */
	syncIsoDateWithDate(event: Event): void {

		// Read the value property to get the ISO string.
		let iso8601 = event.srcElement['value'];  //2017-06-26T08:36
		if (16 === iso8601.length) {
			iso8601 = iso8601 + ":00";
		}
		this.article.date = new Date(iso8601);

	}


	/**
	 * Convert the user's click on a tag to the appropriate
	 * value in the tag.checked property.
	 *
	 * @param {any} $event  Usually a mouse click on a checkbox.
	 */
	tagClick($event: any): void {

		this.itemForm.form.markAsDirty();
		$event.cancelBubble = true;

		for (let tag of this.tags) {

			if ($event.srcElement.dataset['id'] == tag.id) {

				tag.checked = ($event.srcElement.checked) ? 1 : 0;
				break;

			}

		}

	}


	/**
	 * Switch back to the story list.
	 *
	 */
	viewStoryList(): void {

		this.router.navigate(['/articles/list']);

	}

	/**
	 * Reset preview back to hiding when the tab key is pressed.
	 *  
	 * @param $event Key press
	 */
	resetStoryField($event: any): void {
		if ($event.key == 'Tab') {
			if (this.hidePreview == false){
				this.hidePreview = true;
			}
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/articles/item/item.component.ts